<template>
    <span class="cg-return" @click="goBack"><i class="el-icon-arrow-left"></i>返回</span>
</template>

<script>
export default {
    name: 'btn-back',
    methods: {
        goBack() {
            this.$router.go(-1)
        }
    }
}
</script>

<style lang="scss" scoped>
.cg-return {
    cursor: pointer;
    margin-right: 20px;
    
    .el-icon-arrow-left {
        font-weight: bold;
    }
    &:hover {
        opacity: 0.8;
    }
}
</style>
